<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
    <a-modal :title="state.modalTitle" :width="1000" :open="true" :confirmLoading="state.loading" @ok="onFormSubmit"
        @cancel="
            () => {
                emit('cancel')
            }
        ">
        <a-spin :spinning="state.loading">
            <a-form ref="ruleForm" :model="formState" v-bind="formLayout" :rules="rules">
                <a-form-item label="对接人姓名" name="customer_name" required>
                    <a-input placeholder="请输入对接人姓名" v-model:value="formState.customer_name"></a-input>
                </a-form-item>
                <a-form-item label="客户电话" name="customer_tel" required>
                    <a-input placeholder="请输入客户电话" v-model:value="formState.customer_tel"></a-input>
                </a-form-item>
                <a-form-item label="代理身份" name="customer_type" required>
                    <a-radio-group v-model:value="formState.customer_type" button-style="solid"
                        @change="onCustomerTypeChange">
                        <a-radio-button :value="1">个人</a-radio-button>
                        <a-radio-button :value="2">公司</a-radio-button>
                    </a-radio-group>
                </a-form-item>
                <a-form-item label="公司名称/个人姓名" required>
                    <a-input placeholder="请输入就职公司名称" v-model:value="formState.company_name"></a-input>
                </a-form-item>
                <a-form-item label="所在城市" required>
                    <a-input placeholder="请输入" v-model:value="formState.company_city"></a-input>如：长沙，西安
                </a-form-item>
                <a-form-item label="公司统一社会信用代码/个人身份证号" name="finance_social_credit_code"
                    :rules="financeSocialCreditCodeRules">
                    <a-input placeholder="请输入统一社会信用代码" v-model:value="formState.finance_social_credit_code"></a-input>
                </a-form-item>
                <a-form-item label="续费联系人其他号码" name="exigency_tel">
                    <AssociateAuthorization type="number" v-model:value="formState.exigency_tel" @change="validate"
                        placeholder="请输入紧急联系人手机号码" suffixTitle="回车或失去焦点后可以添加多个紧急联系人手机号码" inputType="number">
                    </AssociateAuthorization>
                </a-form-item>
                <a-form-item label="微信昵称" name="wechat_name">
                    <a-input placeholder="请输入微信昵称" v-model:value="formState.wechat_name"></a-input>
                </a-form-item>
                <a-form-item label="微信号" name="wechat_id">
                    <a-input placeholder="请输入微信号" v-model:value="formState.wechat_id"></a-input>
                </a-form-item>

                <a-form-item label="京东包邮金额" name="jd_free_money">
                    <a-input placeholder="请输入" v-model:value="formState.jd_free_money" addonAfter="元"
                        style="width: 200px;" addonBefore="￥"></a-input> 0元或超过此金额则不包邮
                </a-form-item>
                <a-form-item label="顺丰包邮金额" name="sf_free_money">
                    <a-input placeholder="请输入" v-model:value="formState.sf_free_money" addonAfter="元"
                        style="width: 200px;" addonBefore="￥"></a-input> 0元或超过此金额则不包邮
                </a-form-item>
                <div class="form-tips-title">详细信息</div>
                <a-form-item label="邮箱" name="mail_address">
                    <a-input placeholder="请输入邮箱" v-model:value="formState.mail_address"></a-input>
                </a-form-item>
                <a-form-item label="微信头像">
                    <Upload :upload_path="`public/uploads/manage/渠道备案/${dayjs().format('YYYYMM')}/`"
                        :accept="['png', 'jpg', 'jpeg', 'pdf']" uploadType="picture-card" :limitation="1"
                        v-model:value="formState.wechat_picture" uploadText="上传微信头像">
                    </Upload>
                </a-form-item>
                <a-form-item label="身份证人像面照片" name="identity_card_front">
                    <a-upload list-type="picture-card" class="avatar-uploader" :show-upload-list="false"
                        accept=".jpeg,.png,.jpg" :before-upload="beforeUpload" @change="
                            (info) => {
                                handleChange(info, 'identity_card_front')
                            }
                        ">
                        <img class="upload-img" type="" v-if="formState.identity_card_front"
                            :src="$store.state.user.image_domain + formState.identity_card_front" alt="avatar" />
                        <div v-else class="upload-img">
                            <PlusOutlined />
                            <div class="ant-upload-text">上传人像面照片</div>
                        </div>
                    </a-upload>
                </a-form-item>
                <a-form-item label="身份证国徽面照片" name="identity_card_contrary">
                    <a-upload list-type="picture-card" class="avatar-uploader" :show-upload-list="false"
                        accept=".jpeg,.png,.jpg" :before-upload="beforeUpload" @change="
                            (info) => {
                                handleChange(info, 'identity_card_contrary')
                            }
                        ">
                        <img class="upload-img" type="" v-if="formState.identity_card_contrary"
                            :src="$store.state.user.image_domain + formState.identity_card_contrary" alt="avatar" />
                        <div v-else class="upload-img">
                            <PlusOutlined />
                            <div class="ant-upload-text">上传国徽面照片</div>
                        </div>
                    </a-upload>
                </a-form-item>
                <a-form-item label="身份证号码" name="identity_card_number">
                    <a-input placeholder="请输入身份证号码" v-model:value="formState.identity_card_number"></a-input>
                </a-form-item>
                <a-form-item label="身份证有效期开始时间" name="identity_card_start_time">
                    <a-date-picker style="width: 200px" @change="
                        (val, str) => {
                            formState.identity_card_start_time = str
                        }
                    " v-model:value="identity_card_start_time" placeholder="身份证有效期开始时间"></a-date-picker>
                </a-form-item>
                <a-form-item label="身份证有效期结束时间">
                    <a-form-item-rest>
                        <a-date-picker style="width: 200px" @change="
                            (val, str) => {
                                formState.identity_card_expiration_time = str
                            }
                        " v-model:value="identity_card_expiration_time" :disabled="formState.identity_perpetual == 1"
                            placeholder="身份证有效期结束时间"></a-date-picker>
                    </a-form-item-rest>
                    <a-form-item-rest>
                        <a-checkbox class="ml-1x" :checked="formState.identity_perpetual == 1 ? true : false"
                            @change="identityPerpetualChange">长期</a-checkbox>
                    </a-form-item-rest>
                </a-form-item>
                <a-form-item label="住所" name="identity_card_address">
                    <a-input placeholder="住所" v-model:value="formState.identity_card_address"></a-input>
                </a-form-item>
                <a-form-item label="民族" name="nationality">
                    <a-select allow-clear v-model:value="formState.nationality" placeholder="民族">
                        <a-select-option :value="item" v-for="(item, index) in state.nationalityList" :Key="index"> {{
                            item }}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="公司营业执照照片">
                    <Upload :upload_path="`public/uploads/manage/渠道备案/${dayjs().format('YYYYMM')}/`"
                        :accept="['png', 'jpg', 'jpeg', 'pdf']" uploadType="picture-card" :limitation="99"
                        v-model:value="formState.company_business_license" uploadText="上传公司营业执照照片">
                    </Upload>
                </a-form-item>
                <a-form-item label="就职公司地址">
                    <a-input placeholder="请输入就职公司地址" v-model:value="formState.company_address"></a-input>
                </a-form-item>
                <a-form-item label="职位名称">
                    <a-input placeholder="请输入职位名称" v-model:value="formState.job_title"></a-input>
                </a-form-item>
                <a-form-item label="证明材料">
                    <Upload :upload_path="`public/uploads/manage/渠道备案/${dayjs().format('YYYYMM')}/`"
                        :accept="['png', 'jpg', 'jpeg', 'pdf']" uploadType="text" :limitation="99"
                        v-model:value="formState.job_certificate" uploadText="上传证明材料">
                    </Upload>
                </a-form-item>
                <div class="form-tips-title">默认收货地址</div>
                <a-form-item label="证章收件人姓名">
                    <a-input placeholder="请输入" v-model:value="formState.recipient_name"></a-input>
                </a-form-item>
                <a-form-item label="证章收件人电话" name="recipient_mobile">
                    <a-row>
                        <a-col :span="16">
                            <a-input v-model:value="formState.recipient_mobile" @change="
                                (v) => {
                                    phoneChange(v, 'recipient_mobile')
                                }
                            " placeholder="请输入收件人电话"></a-input>
                        </a-col>
                        <a-col :span="7">
                            <a-button :loading="state.receiveLoading" type="primary" @click="getMailling()"
                                style="margin-left: 12px" :icon="h(CloudDownloadOutlined)">自动获取</a-button>
                        </a-col>
                    </a-row>
                </a-form-item>
                <a-form-item label="证章收件人省市区" name="recipient_paua">
                    <AddressCascader width="100%" v-model:value="formState.recipient_paua" @change="recipientChange">
                    </AddressCascader>
                </a-form-item>
                <a-form-item label="证章收件人详细地址" name="recipient_address">
                    <a-textarea placeholder="请选择寄件人详细地址" v-model:value="formState.recipient_address"
                        @blur="receiveAddressChange" />
                    <a-button type="primary" @click="parseReceiveAddress" :loading="state.parseReceiveAddressLoading"
                        style="margin-top: 5px;" :icon="h(ScanOutlined)">识别</a-button>
                </a-form-item>
                <a-form-item label="是否默认自动填上">
                    <a-radio-group v-model:value="formState.recipient_auto" button-style="solid">
                        <a-radio-button :value="1">是</a-radio-button>
                        <a-radio-button :value="2">否</a-radio-button>
                    </a-radio-group>
                </a-form-item>
            </a-form>
        </a-spin>
        <image-cropper @cancel="
            () => {
                state.showCropper = false
            }
        " :imageUrl="state.imageUrl" :upload_path="`public/uploads/manage/渠道备案/${dayjs().format('YYYYMM')}/`"
            :imageName="state.imageName" @change="cropperChange" v-if="state.showCropper"></image-cropper>
    </a-modal>
</template>

<script lang="ts" setup name="createTemplate">
import { Upload } from '@/components'
import { reactive, ref, onMounted, computed, h, nextTick } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { AssociateAuthorization } from '@/components'
import { PlusOutlined, DeleteOutlined, CloudDownloadOutlined, ScanOutlined } from '@ant-design/icons-vue'
import ImageCropper from '@/components/ImageCropper/index.vue'
import { useStore } from 'vuex'
import AddressCascader from '@/components/base/AddressCascader.vue'
import { mobileRequiredValidator, parseAddress } from '@/utils/util'
import dayjs from 'dayjs'
const format = 'YYYY-MM-DD'
const $store = useStore()

const props = defineProps({
    detailData: {
        type: Object,
        default: () => null
    }
})
const emit = defineEmits(['cancel'])
const ruleForm = ref()
let validateEnd = (rule, value) => {
    if (!value && formState.identity_perpetual != 1) {
        return Promise.reject(new Error('请选择身份证结束日期'))
    } else {
        return Promise.resolve()
    }
}
const rules = {
    customer_tel: [{ required: true, validator: mobileRequiredValidator }]
}
const formLayout = {
    labelCol: {
        xs: { span: 7 },
        sm: { span: 7 }
    },
    wrapperCol: {
        xs: { span: 10 },
        sm: { span: 10 }
    }
}
const state = reactive<any>({
    modalTitle: '新增备案',
    loading: false,
    currentUpload: '',
    imageName: '',
    imageUrl: '',
    showCropper: false,
    nationalityList: [
        '汉族',
        '蒙古族',
        '回族',
        '藏族',
        '维吾尔族',
        '苗族',
        '彝族',
        '壮族',
        '布依族',
        '朝鲜族',
        '满族',
        '侗族',
        '瑶族',
        '白族',
        '土家族',
        '哈尼族',
        '哈萨克族',
        '傣族',
        '黎族',
        '傈僳族',
        '佤族',
        '畲族',
        '高山族',
        '拉祜族',
        '水族',
        '东乡族',
        '纳西族',
        '景颇族',
        '柯尔克孜族',
        '土族',
        '达斡尔族',
        '仫佬族',
        '羌族',
        '布朗族',
        '撒拉族',
        '毛南族',
        '仡佬族',
        '锡伯族',
        '阿昌族',
        '普米族',
        '塔吉克族',
        '怒族',
        '乌孜别克族',
        '俄罗斯族',
        '鄂温克族',
        '德昂族',
        '保安族',
        '裕固族',
        '京族',
        '塔塔尔族',
        '独龙族',
        '鄂伦春族',
        '赫哲族',
        '门巴族',
        '珞巴族',
        '基诺族',
        '其他',
        '外国血统'
    ],
    receiveLoading: false,
})

interface formState {
    customer_name: string
    customer_tel: string
    customer_type: number
    company_city: string
    exigency_tel: string
    mail_address: string
    wechat_id: string
    wechat_name: string
    wechat_picture: string
    identity_card_front: string
    identity_card_contrary: string
    identity_card_number: string
    identity_card_address: string
    identity_card_expiration_time: string
    identity_card_start_time: string
    identity_perpetual: number
    nationality: string | null
    company_name: string
    finance_social_credit_code: string
    company_business_license: string
    company_address: string
    job_title: string
    job_certificate: string
    recipient_auto: number
    recipient_name: string
    recipient_mobile: string
    recipient_paua: string | undefined
    recipient_address: string
    sf_free_money: number
    jd_free_money: number

}
let formState = reactive<formState>({
    customer_name: '',
    customer_tel: '',
    customer_type: 2,
    company_city: '',
    exigency_tel: '',
    mail_address: '',
    wechat_id: '',
    wechat_name: '',
    wechat_picture: '',
    identity_card_front: '',
    identity_card_contrary: '',
    identity_card_start_time: '',
    identity_card_expiration_time: '',
    identity_perpetual: 2,
    identity_card_number: '',
    identity_card_address: '',
    nationality: null,
    company_name: '',
    finance_social_credit_code: '',
    company_business_license: '',
    company_address: '',
    job_title: '',
    job_certificate: '',
    recipient_auto: 2,
    recipient_name: '',
    recipient_mobile: '',
    recipient_paua: undefined,
    recipient_address: '',
    sf_free_money: 0,
    jd_free_money: 0
})

// ============ 动态规则：公司身份时「统一社会信用代码」必填，个人时非必填 ============
const financeSocialCreditCodeRules = computed(() => {
    if (formState.customer_type === 2) {
        return [{ required: true, message: '请输入公司统一社会信用代码', trigger: 'blur' }]
    }
    return []
})

// 切换身份时清一下旧校验提示
const onCustomerTypeChange = () => {
    nextTick(() => {
        ruleForm.value?.clearValidate(['finance_social_credit_code'])
    })
}

onMounted(() => {
    if (props.detailData?.id) {
        state.modalTitle = '编辑备案'
        queryDetail(props.detailData.id)
    }
})
const identity_card_start_time = computed(() => {
    return formState.identity_card_start_time ? dayjs(formState.identity_card_start_time, format) : null
})
const identity_card_expiration_time = computed(() => {
    return formState.identity_card_expiration_time ? dayjs(formState.identity_card_expiration_time, format) : null
})

const queryDetail = (id) => {
    state.loading = true
    let requeryParam = {
        url: `/admin/v1/filings/${id}/edit`,
        method: 'get'
    }
    baseService(requeryParam).then((res) => {
        state.loading = false
        Object.assign(formState, res.data)
    })
}
const identityPerpetualChange = (val) => {
    formState.identity_perpetual = val.target.checked ? 1 : 2
    ruleForm.value.validate('identity_card_expiration_time')
}
const validate = () => {
    ruleForm.value.validate('exigency_tel')
}
// 图片上传
const handleChange = (info, type) => {
    state.currentUpload = type
    const reader: any = new FileReader()
    state.imageName = info.file.name
    reader.readAsDataURL(info.file)
    reader.onload = () => {
        state.imageUrl = reader.result
        state.showCropper = true
    }
}

// 手动上传验证
const beforeUpload = (file) => {
    return false
}

// 裁剪成功
const cropperChange = (res, isRecognize) => {
    if (isRecognize) {
        if (!res.data.身份证识别实体信息) {
            message.error('识别失败，请重新上传')
            return
        }
        let data = res.data.身份证识别实体信息
        if (state.currentUpload == 'identity_card_contrary') {
            if (data.身份证国徽面实体信息.有效期限.length < 1) {
                message.error('请上传身份证国徽面照片')
                formState.identity_card_contrary = ''
                return
            }
            let list = data.身份证国徽面实体信息.有效期限.split('-').map((item, index) => {
                return item.replaceAll('.', '-')
            })
            let obj = {
                identity_card_start_time: list[0],
                identity_card_expiration_time: list[1],
                identity_perpetual: list[1] == '长期' ? 1 : 2
            }
            Object.assign(formState, obj)
        } else if (state.currentUpload == 'identity_card_front') {
            if (data.身份证人像面实体信息.姓名.length < 1) {
                message.error('请上传身份证人像面照片')
                formState.identity_card_front = ''
                return
            }
            let nationality: any = null
            state.nationalityList.forEach((item) => {
                if (item.indexOf(data.身份证人像面实体信息.民族) > -1) {
                    nationality = item
                }
            })
            let obj = {
                customer_name: data.身份证人像面实体信息.姓名,
                identity_card_address: data.身份证人像面实体信息.住址,
                identity_card_number: data.身份证人像面实体信息.身份证号,
                nationality: nationality
            }
            Object.assign(formState, obj)
        }
        formState[state.currentUpload] = res.data.url
    } else {
        formState[state.currentUpload] = res.url
    }
    state.showCropper = false
    ruleForm.value.validate(state.currentUpload)
}
// 获取邮寄信息
const getMailling = () => {
    var tel = formState.recipient_mobile
    if (!tel) {
        message.warn('请填写手机号码再获取邮寄信息')
        return
    }
    state.receiveLoading = true
    //这个接口是用的客户管理的顺丰邮寄相同的接口
    let requeryParam = {
        url: '/admin/v1/mailingAddressList',
        method: 'post',
        data: {
            page: 1,
            limit: 'all',
            customer_tel: tel
        }
    }
    baseService(requeryParam)
        .then((res: any) => {
            if (res.data.list?.length > 0) {
                formState.recipient_name = res.data.list[0].name
                formState.recipient_mobile = res.data.list[0].tel
                formState.recipient_address = res.data.list[0].address
                formState.recipient_paua = `${res.data.list[0].recipient_province_id},${res.data.list[0].recipient_city_id},${res.data.list[0].recipient_area_id}`
                state.receiveLoading = false
            }
            message.success(res.msg)
        })
        .catch((res) => {
            if (res) {
                state.receiveLoading = false
                if (res.msg) {
                    message.warning(res.msg)
                    return
                }
            }
        })
}
const recipientChange = (e, val) => {
    let address = `${val[0].name}${val[1].name}${val[2].name}`
    formState.recipient_address = address
}
//寄件人详细地址改变
const receiveAddressChange = () => {
    if (formState.recipient_paua) {
        let arr = formState.recipient_paua.split(',')
        let requestParam = {
            url: '/admin/areaList?province=' + arr[0] + '&city=' + arr[1] + '&area=' + arr[2],
            method: 'get'
        }
        baseService(requestParam).then((res: any) => {
            if (res.data.length == 3) {
                let head3 = res.data[0].name + res.data[1].name + res.data[2].name
                let head2 = res.data[1].name + res.data[2].name
                let head1 = res.data[2].name
                formState.recipient_address = formState.recipient_address.trim()
                if (formState.recipient_address.indexOf(head3) == 0) {
                    formState.recipient_address = formState.recipient_address.replace(head3, '')
                } else if (formState.recipient_address.indexOf(head2) == 0) {
                    formState.recipient_address = formState.recipient_address.replace(head2, '')
                } else if (formState.recipient_address.indexOf(head1) == 0) {
                    formState.recipient_address = formState.recipient_address.replace(head1, '')
                }
                formState.recipient_address = head3 + formState.recipient_address
            }
        })
    }
}
//识别收货地址
const parseReceiveAddress = () => {
    state.parseReceiveAddressLoading = true
    parseAddress(formState.recipient_address).then((res: any) => {
        if (res.name) {
            formState.recipient_name = res.name
        }
        if (res.phone) {
            formState.recipient_mobile = res.phone
        }
        if (res.area_ids) {
            formState.recipient_paua = res.area_ids
        }
        if (res.address) {
            formState.recipient_address = res.address
        }
    }).catch((res) => {
        message.error(res)
    }).finally(() => {
        state.parseReceiveAddressLoading = false
    })
}
const onFormSubmit = () => {
    ruleForm.value
        .validate()
        .then(() => {
            state.loading = true
            if (props.detailData?.id > 0) {
                let requeryParam = {
                    url: '/admin/v1/filings/' + props.detailData.id,
                    method: 'put',
                    data: formState
                }
                baseService(requeryParam)
                    .then((res: any) => {
                        state.loading = false
                        message.success(res.msg)
                        emit('cancel')
                    })
                    .catch((res) => {
                        state.loading = false
                        if (res.msg) {
                            message.error(res.msg)
                        } else {
                            message.error('操作失败')
                        }
                    })
            } else {
                let requeryParam = {
                    url: '/admin/v1/filings',
                    method: 'post',
                    data: formState
                }
                baseService(requeryParam)
                    .then((res: any) => {
                        state.loading = false
                        message.success(res.msg)
                        emit('cancel')
                    })
                    .catch((res) => {
                        state.loading = false
                        if (res.msg) {
                            message.error(res.msg)
                        } else {
                            message.error('操作失败')
                        }
                    })
            }
        })
        .catch(() => { })
}
const phoneChange = (v, type) => {
    let str = v.target.value.replaceAll(/\D/g, '')
    formState[type] = str
}
</script>

<style lang="less" scoped>
.avatar-uploader {
    :deep(.ant-upload.ant-upload-select-picture-card) {
        width: 300px !important;
        height: 200px !important;
    }
}

.upload-img {
    width: 300px;
    height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.muti-area {
    cursor: pointer;
}
</style>
